import { useEffect, useState } from 'react';

/** Az aktuális idő ezredmásodpercben, `lepesMs`-onként frissítve (az SLA-csíkok közös órája). */
export function useMost(lepesMs: number): number {
  const [most, setMost] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setMost(Date.now()), lepesMs);
    return () => clearInterval(t);
  }, [lepesMs]);
  return most;
}
